import { useState, forwardRef } from "react";
import axios from "axios";
import styles from "./register.module.css";

const Register = forwardRef((props, ref) => {
  const [form, setForm] = useState({
    fullName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  const [message, setMessage] = useState("");
  const [showPopup, setShowPopup] = useState(false);

  const onClose = () => {
    setShowPopup(false)
  }

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const validate = () => {
    let newErrors = {};

    if (!form.fullName.trim()) {
      newErrors.fullName = "Vui lòng nhập họ và tên";
    }

    if (!form.email) {
      newErrors.email = "Vui lòng nhập email";
    } else if (!/\S+@\S+\.\S+/.test(form.email)) {
      newErrors.email = "Email không hợp lệ";
    }

    if (!form.phone) {
      newErrors.phone = "Vui lòng nhập số điện thoại";
    } else if (!/^[0-9]{9,11}$/.test(form.phone)) {
      newErrors.phone = "Số điện thoại không hợp lệ";
    }

    if (!form.message.trim()) {
      newErrors.message = "Vui lòng nhập nội dung tư vấn";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    if (!window.confirm("Bạn xác nhận gửi thông tin nhận tư vấn?")) return;

    try {
      setLoading(true);
      const response = await axios.post("https://duhochanquocnewlife.com/api/consultations/createConsulation", form);
      setMessage(response.data.message);
      setShowPopup(true);
      setForm({
        fullName: "",
        email: "",
        phone: "",
        message: "",
      });
    } catch (error) {
      alert("Có lỗi xảy ra, vui lòng thử lại");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div ref={ref} id="register_form" className={styles.register_form}>
        <form onSubmit={handleSubmit}>
          <h2>Đăng ký ngay hôm nay để nhận tư vấn miễn phí!</h2>
          {/* Họ và tên */}
          <div className={styles.form_group}>
            <label htmlFor="fullName">Họ và tên: <span className={styles.red}>*</span></label>
            <input
              id="fullName"
              className={styles.input}
              name="fullName"
              placeholder="Nhập họ và tên"
              value={form.fullName}
              onChange={handleChange}
            />
            {errors.fullName && <p className={styles.error}>{errors.fullName}</p>}
          </div>

          {/* Email */}
          <div className={styles.form_group}>
            <label htmlFor="email">Email: <span className={styles.red}>*</span></label>
            <input
              id="email"
              className={styles.input}
              name="email"
              placeholder="Nhập email"
              value={form.email}
              onChange={handleChange}
            />
            {errors.email && <p className={styles.error}>{errors.email}</p>}
          </div>

          {/* Số điện thoại */}
          <div className={styles.form_group}>
            <label htmlFor="phone">Số điện thoại: <span className={styles.red}>*</span></label>
            <input
              id="phone"
              className={styles.input}
              name="phone"
              placeholder="Nhập số điện thoại"
              value={form.phone}
              onChange={handleChange}
            />
            {errors.phone && <p className={styles.error}>{errors.phone}</p>}
          </div>

          {/* Nội dung tư vấn */}
          <div className={styles.form_group}>
            <label htmlFor="message">Nội dung tư vấn: <span className={styles.red}>*</span></label>
            <textarea
              id="message"
              className={styles.textarea}
              name="message"
              placeholder="Nhập nội dung cần tư vấn"
              value={form.message}
              onChange={handleChange}
            />
            {errors.message && <p className={styles.error}>{errors.message}</p>}
          </div>

          <button type="submit" className={styles.btn} disabled={loading}>
            {loading ? "Đang gửi..." : "Nhận tư vấn miễn phí"}
          </button>
        </form>
      </div>

      {showPopup && (
        <div className={styles.popup_overlay} onClick={onClose}>
          <div 
            className={styles.popup}
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Thông báo</h3>
            <p>{message}</p>
            <button onClick={onClose}>Đóng</button>
          </div>
        </div>
      )}
    </>
  );
});

export default Register;
